<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("configuracionCarta") }}
            </li>
          </ol>
        </nav>
      </div>



      <div class="col-md-4" v-if="grupoProductos">
        <h2><i class="fa fa-th-large"></i> {{ $t("productos") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link v-if="productos" :to="{ name: 'productos-carta' }">
                <li>
                  {{ $t("productos") }}<br />
                  <span class="text-muted"
                    ><strong>{{ $t("componentesDeVenta") }}</strong>
                    {{ $t("delNegocioAClientes") }}</span
                  >
                </li>
              </router-link>
              <router-link v-if="categorias" :to="{ name: 'categorias-carta' }">
                <li>
                  {{ $t("categorias") }}<br />
                  <span class="text-muted"
                    >{{ $t("clasificacionDe") }}
                    <strong>{{ $t("productosPorFamilia") }}</strong></span
                  >
                </li>
              </router-link>

              <router-link
                v-if="materiasPrimas && !esSelfi"
                :to="{ name: 'materias-primas-carta' }"
              >
                <li>
                  {{ $t("materiasPrimas") }}<br />
                  <span class="text-muted"
                    >{{ $t("sustanciasQue") }}
                    <strong> {{ $t("componenALosProductos") }}</strong></span
                  >
                </li>
              </router-link>
              <router-link v-if="menus && !esSelfi" :to="{ name: 'menus-carta' }">
                <li>
                  {{ $t("menus") }}<br />
                  <span class="text-muted">{{ $t("descripcionMenus") }}</span>
                </li>
              </router-link>
              <router-link
                v-if="productos && !esSelfi"
                :to="{ name: 'restricciones-productos' }"
              >
                <li>
                  {{ $t("restriccionesProductos") }}<br />
                  <span class="text-muted">{{
                    $t("restriccionesProductosDesc")
                  }}</span>
                </li>
              </router-link>

              <router-link
                v-if="mostrarPlanificador && productos && !esSelfi"
                :to="{ name: 'planificador-carta' }"
              >
                <li>
                  Planificador de la carta<br />
                  <span class="text-muted">
                    Configura productos para mostrarlos en una fecha concreta
                  </span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="formasPago && !esSelfi">
        <h2><i class="fas fa-credit-card"></i> {{ $t("formasDePago") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'formas-de-pago-carta' }">
                <li>
                  {{ $t("formasDePago") }}<br />
                  <span class="text-muted"
                    ><strong>{{ $t("metodosDeCobro") }}</strong>
                    {{ $t("enElFrontalDeVenta") }}</span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="negocio">
        <h2><i class="fas fa-building"></i> {{ $t("negocio") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'informacion-carta' }">
                <li>
                  {{ $t("negocio") }}<br />
                  <span class="text-muted"
                    >{{ $t("informacionAcercaDel") }}
                    <strong>{{ $t("negocioMinuscula") }}</strong></span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>
      <div class="col-md-4" v-if="horarios">
        <h2><i class="fas fa-clock"></i> {{ $t("horarios") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'horarios-carta' }">
                <li>
                  {{ $t("horarios") }}<br />
                  <span class="text-muted">{{
                    $t("modificarHorariosDeLaCarta")
                  }}</span>
                </li>
              </router-link>
              <router-link :to="{ name: 'restriccion-horarios' }" v-if="!esSelfi">
                <li>
                  {{ $t("restriccionHorarios") }}<br />
                  <span class="text-muted">{{
                    $t("restriccionHorariosDesc")
                  }}</span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>
      <div class="col-md-4" v-if="horarios && !esSelfi">
        <h2><i class="fas fa-map-marked-alt"></i> {{ $t("mapasYZonas") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'zonas-carta' }">
                <li>
                  {{ $t("zonas") }}<br />
                  <span class="text-muted">{{
                    $t("modificarZonasDeLaCarta")
                  }}</span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="negocio">

        <h2><i class="fas fa-paint-brush"></i> {{ $t("personalizacion") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'personalizar-carta' }">
                <li>
                  {{ $t("personalizacionCarta") }}<br />
                  <span class="text-muted"
                    ><strong>{{ $t("personalizacionCarta") }}</strong
                    >{{ $t("conLasOpcionesQueTeOfrecemos") }}</span
                  >
                </li>
              </router-link>
              <router-link :to="{ name: 'idiomas-carta' }">
                <li>
                  {{ $t("idiomas") }}<br />
                  <span class="text-muted"
                    >Activa o desactiva <strong>{{ $t("idiomas") }}</strong> y
                    ordénalos</span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>

      <div class="col-md-4" v-if="negocio && !esSelfi">
        <h2><i class="fas fa-stethoscope"></i> {{ $t("diagnosis") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'diagnostico-carta' }">
                <li>
                  Diagnóstico<br />
                  <span class="text-muted"
                    ><strong
                      >{{ $t("comprobacionProducts") }} y materias
                      primas</strong
                    ></span
                  >
                </li>
              </router-link>
            </ul>
          </div>
        </card>
      </div>
        <div class="col-md-4" v-if="negocio && !esSelfi">
          <div v-if="userIdsForSFCKiosk.includes(getIdUser()) ">
            <h2><i class="fa-solid fa-mobile-screen-button"></i> {{ $t("kioskos") }}</h2>
        <card>
          <div class="content-card">
            <ul class="list-files">
              <router-link :to="{ name: 'kioskos-carta' }">
                <li>
                  {{ $t("stockBreak") }}<br />
                  <span class="text-muted">
                    <strong>
                      {{ $t("stockBreak") }} 
                    </strong>
                    </span>
                </li>
              </router-link>
            </ul>
          </div>
        </card>
          </div>
        
      </div>




    </div>
  </div>
</template>

<script>
import { jwtDecode } from "jwt-decode";


export default {
  name: "ConfiguracionCarta",

  created() {
    this.$store.dispatch("setNameRoute", "Configuración carta");
    this.restrictions();
    this.checkMostrarPlanificador();
    this.checkIsSelfi();
  },
  data() {
    return {
      mostrarPlanificador: false,
      productos: true,
      categorias: true,
      formasPago: true,
      negocio: true,
      materiasPrimas: true,
      horarios: true,
      menus: true,
      grupoProductos: true,
      esSelfi: false,

      userIdsForSFCKiosk : ["4326", "4555", "4557", "4559", "4560"]
    };
  },

  methods: {
    decodeJWT() {
      return this.$store.getters.jwt ? jwtDecode(this.$store.getters.jwt) : {};
    },
    getIdUser(){
      return this.decodeJWT().idUser
    },
    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },

    checkMostrarPlanificador() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          //1 es gestión de personal
          idConfig: 108,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfigByUser", config)
        .then(function(response) {
          if (response.data.response) {
            vm.mostrarPlanificador = response.data.result;
          } else {
            console.error("Ha ocurrido un error al comprobar la configuración");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    restrictions() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "general/getRestrictionsByUser",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              switch (response.data.result[i].idRestriction) {
                case "60":
                  vm.productos = false;
                  break;
                case "61":
                  vm.categorias = false;
                  break;
                case "62":
                  vm.formasPago = false;
                  break;
                case "63":
                  vm.negocio = false;
                  break;
                case "65":
                  vm.materiasPrimas = false;
                  break;
                case "66":
                  vm.horarios = false;
                  break;
                case "67":
                  vm.menus = false;
                  break;
              }
            }

            if (!vm.productos && !vm.categorias) {
              vm.grupoProductos = false;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
h2 {
  margin: 10px 0px;
  font-family: "Numier", "Helvetica Neue", Arial;
  /* color: #1E22AA; */
  color: #1E22AA;
  font-size: 25px;
  font-weight: bold;
}

i {
  font-size: 25px;
}

.list-files {
  padding: 0;
  margin-bottom: 0px;
}

.list-files a:first-child li {
  border-top: none;
}

.list-files a li {
  list-style: none;
  padding: 15px 20px;
  font-size: 1.1em;
  border-top: 1px solid #bbb;
  color: #252422;
}

.list-files a li span {
  font-size: 0.7em;
}

.list-files a li:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.2);
}

.content-card {
  border-top: 2px solid #00A3AD;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/ConfiguracionCarta.vue